import {DRVBundGlobals} from '@zs21/drv-bund-common-ilias-utils';
import $ from 'jquery';
import {toXML} from 'jstoxml/jstoxml';
import * as xlsx from 'xlsx';
import {readFile} from '../FileUpload/FileUpload';

export const blockedEmailDomains = [
    'drv-bund.de',
    'kbs.de',
    'drv-saarland.de',
    'drv-rlp.de',
    'drv-rheinland.de',
    'drv-oldenburg-bremen.de',
    'drv-nordbayern.de',
    'drv-nord.de',
    'drv-md.de',
    'drv-hessen.de',
    'drv-bsh.de',
    'drv-bw.de',
    'drv-berlin-brandenburg.de',
    'drv-schwaben.de',
    'drv-westfalen.de',
    'drv-bayernsued.de',
    'now-it.de',
    'rehazentrum-bad-eilsen.de',
    'rehazentrum-bp.de',
    'rehazentrum-oberharz.de',
    'klinik-teutoburger-wald.de',
    'eifelklinik.de',
    'lahntalklinik.de',
    'klinik-niederrhein.de',
    'klinik-roderbirken.de',
    'nordseeklinik-borkum.de',
    'aggertalklinik.de',
    'westerwaldklinik.de',
    'rheuma-liga-nrw.de',
];

function randomIntInclusive(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
}

export function generatePassword(length = 0) {
    const UPPERCASE_CHARS = 'ACDEFGHJKMNPQRSTUVWXYZ';
    const MIN_LENGTH = 8;

    const charsetConfigs = [
        {charset: UPPERCASE_CHARS, min: 1},
        {charset: UPPERCASE_CHARS.toLowerCase(), min: 1},
        {charset: '_+?#-*@$%', min: 1, max: 1},
        {charset: '2345679', min: 1},
    ];
    const charsetConfigsAmount = charsetConfigs.length;

    const charsets = [];
    for (let i = 0; i < charsetConfigsAmount; i++) {
        for (let x = 0; x < charsetConfigs[i].min; x++) {
            charsetConfigs[i].amount = (charsetConfigs[i].amount ?? 0) + 1;
            charsets.push(i);
        }
    }

    const passwordLength = Math.max(MIN_LENGTH, Math.max(charsets.length, length));
    while (charsets.length < passwordLength) {
        const index = randomIntInclusive(0, charsetConfigsAmount - 1);
        const charsetConfig = charsetConfigs[index];
        const amount = charsetConfig.amount ?? 0;

        if (charsetConfig.max === undefined || amount < charsetConfig.max) {
            charsetConfig.amount = amount + 1;
            charsets.push(index);
        }
    }

    const passwordChars = [];
    while (charsets.length > 0) {
        const index = randomIntInclusive(0, charsets.length - 1);
        const charset = charsetConfigs[charsets.splice(index, 1)[0]].charset;
        passwordChars.push(charset[randomIntInclusive(0, charset.length -1)]);
    }

    return passwordChars.join('');
}

export async function importUsersFromFile(file, defaultPassword) {
    const users = importExcel(await readFile(file)).filter((user) => {
        for (const domain of blockedEmailDomains) {
            if (user.email.toLowerCase().endsWith(domain.toLowerCase())) {
                return false;
            }
        }

        return true;
    });

    return await importUsers(users.map((user) => {
        user.password = defaultPassword;
        return user;
    }));
}

export async function fetchJQuery(url, init = {}) {
    return $(await (await fetch(url.startsWith('http') ? url : DRVBundGlobals.ILIAS_BASE_ADDRESS + '/' + url, {...init, credentials: 'include'})).text());
}

export async function importUsers(users) {
    const xmlData = new Blob([createUserImportXML(users)], {type: 'text/xml'});

    const userManagementPage = await fetchJQuery('/ilias.php?baseClass=ilAdministrationGUI&ref_id=7&cmd=jump');
    const userImportUploadPageUrl = userManagementPage.find('a[href*="baseClass=iladministrationgui"][href*="cmdClass=ilObjUserFolderGUI"][href*="cmd=importUserForm"]').attr('href');
    if (userImportUploadPageUrl === undefined) {
        throw new Error('Failed to resolve user import url');
    }

    const userImportUploadPage = await fetchJQuery(userImportUploadPageUrl);
    const userImportUploadForm = userImportUploadPage.find('#form_');
    const formData = new FormData();
    formData.append('ilfilehash', userImportUploadForm.find('#ilfilehash').val());
    formData.append('cmd[importUserRoleAssignment]', userImportUploadForm.find('[name="cmd[importUserRoleAssignment]"]').val());
    formData.append('importFile', xmlData, 'external_users.xml');

    const userImportFormPage = await fetchJQuery(userImportUploadForm.attr('action'), {method: 'post', body: formData});
    const userImportForm = userImportFormPage.find('#il_center_col > form');
    userImportForm.find('[disabled]').removeAttr('disabled');
    const conflictSelect = userImportForm.find('select[name="form/input_7/input_8"]');

    const formDataImportForm = new FormData(userImportForm[0]);
    formDataImportForm.delete('form/input_9/input_10');
    formDataImportForm.set(conflictSelect.attr('name'), '3');
    const resultPage = await fetchJQuery(userImportForm.attr('action'), {method: 'post', body: formDataImportForm});

    const successElement = resultPage.find('.alert.alert-success');
    const errorElement = resultPage.find('.alert.alert-danger');

    if (errorElement.length > 0) {
        throw new Error(errorElement.text());
    }

    if (successElement.length > 0) {
        const ignored = {};

        successElement.find('tr[class^="tblrow"]').each(function (index, element) {
            const cells = $(element).find('td');
            const email = cells.eq(0).text().trim();

            ignored[email] = true;
        });

        const results = [];
        for (const user of users) {
            results.push({
                email: user.email, // @TODO: return user instead
                result: ignored[user.email] ? 'ignored' : 'created'
            });
        }

        return results;
    }

    throw new Error('Failed to import users');
}

function importExcel(content) {
    const workbook = xlsx.read(content, { type: 'array' });
    const jsonData = xlsx.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);

    const requiredColumns = {
        participantName: 'Teilnehmername',
        externalEmail: 'externe Mailadresse',
        bookingPriority: 'Buchungspriorität',
    };
    const requiredColumnNames = Object.values(requiredColumns);

    const hasRequiredColumnNames = (row) => {
        for (const requiredColumnName of requiredColumnNames) {
            if (!(requiredColumnName in row)) {
                return false;
            }
        }

        return true;
    }

    const users = [];
    for (const row of jsonData) {
        if (!hasRequiredColumnNames(row)) {
            continue;
        }

        const name = row[requiredColumns.participantName].trim();
        const email = row[requiredColumns.externalEmail].trim().toLowerCase();
        const bookingPriority = row[requiredColumns.bookingPriority].toString().trim().toLowerCase();

        if (!name || !email || (bookingPriority && parseInt(bookingPriority) >= 90)) {
            continue;
        }

        users.push({...splitName(name), name, email});
    }

    if (users.length === 0) {
        throw new Error('Die Datei enthält keine Teilnehmerdaten (Vor- und Nachname sowie E-Mail-Adresse) mit Buchungspriorität < 90');
    }

    return users;
}

function splitName(name) {
    const result = {firstName: '', lastName: '', title: ''};

    const vMailBestandteile = name.trim().split(' ');
    const vTitelBezeichner = ['PROF', 'DR', 'MED'];
    const vAdelsBezeichner = ['VON', 'VOM', 'ZU', 'ZUM', 'UND'];

    //Extern weghauen
    if (vMailBestandteile.indexOf('extern') > -1 || vMailBestandteile.indexOf('Extern') > -1) {
        vMailBestandteile.pop();
    }

    //ist noch mindest ein Vor- und Nachname vorhanden?
    if (vMailBestandteile.length > 1) {
        let k;

        //Nachname setzten
        // --> Adelstitel Check
        let vAdelTitelGefunden = false;
        for (k = 0; k < vMailBestandteile.length; k++) {
            if (vAdelsBezeichner.indexOf(vMailBestandteile[k].toUpperCase()) > -1) {
                vAdelTitelGefunden = true;
            }
            if (vAdelTitelGefunden) {
                if (vAdelsBezeichner.indexOf(vMailBestandteile[k].toUpperCase()) > -1) {                       //Adeltitel kleingeschrieben
                    result.lastName = result.lastName.concat(vMailBestandteile[k].toLowerCase()).concat(' ');
                } else {
                    result.lastName = result.lastName.concat(vMailBestandteile[k].substr(0, 1).toUpperCase())   //Nachnamen mit großen Anfangsbuchstaben
                        .concat(vMailBestandteile[k].substr(1, vMailBestandteile[k].length - 1).toLowerCase()).concat(' ');
                }
            }
        }
        //--> wenn kein Adelstitel vorhanden ist, soll einfach der letzte Teil der Mailbestandteile als Nachname angenommen werden
        if (!vAdelTitelGefunden) {
            result.lastName = result.lastName.concat(vMailBestandteile[vMailBestandteile.length - 1].substr(0, 1).toUpperCase())   //Nachnamen mit großen Anfangsbuchstaben
                .concat(vMailBestandteile[vMailBestandteile.length - 1].substr(1, vMailBestandteile[vMailBestandteile.length - 1].length - 1).toLowerCase());
        } else {
            result.lastName = result.lastName.trim(); //vorherige Schleifendurchlauf bedingtes Leerzeichen am Ende weg
        }

        //Vorname und Titel festlegen
        //
        for (k = 0; k < vMailBestandteile.length - 1; k++) {
            if (vTitelBezeichner.indexOf(vMailBestandteile[k].toUpperCase()) > -1) {
                result.title = result.title.concat(vMailBestandteile[k].substr(0, 1).toUpperCase())   //Titel mit großen Anfangsbuchstaben
                    .concat(vMailBestandteile[k].substr(1, vMailBestandteile[k].length - 1).toLowerCase()).concat('. ');
            } else if (vAdelsBezeichner.indexOf(vMailBestandteile[k].toUpperCase()) > -1) {
                break;
            } else {
                result.firstName = result.firstName.concat(vMailBestandteile[k].substr(0, 1).toUpperCase())   //Vornamemit großen Anfangsbuchstaben
                    .concat(vMailBestandteile[k].substr(1, vMailBestandteile[k].length - 1).toLowerCase()).concat(' ');
            }
        }
        result.firstName = result.firstName.trim();
        result.title = result.title.trim();

        if (result.title.length === 0) {
            result.title = ' ';
        }
    }

    if (result.firstName.length === 0) {
        result.firstName = 'Unbekannt';
    }

    if (result.lastName.length === 0) {
        result.lastName = 'Unbekannt';
    }

    return result;
}

function createUserImportXML(users) {
    // const GLOBAL_ROLES: {[key: string]: string} = {'il_11979_role_102887': 'MIW_Standardnutzer'};
    const GLOBAL_ROLES = {'il_13738_role_46866': 'MIW_Standardnutzer'};

    const ROOT_URL = DRVBundGlobals.ILIAS_BASE_ADDRESS;
    const XML_HEAD = `<?xml version="1.0" encoding="utf-8"?>
<!DOCTYPE Users PUBLIC "-//ILIAS//DTD UserImport//EN" "${ROOT_URL}xml/ilias_user_5_1.dtd">
<Users>
    <UDFDefinitions>
        <UDFDefinition Id="il_13738_udf_1" Type="TEXT" Visible="FALSE" Changeable="FALSE" Required="FALSE"
                       Searchable="TRUE" CourseExport="TRUE" GroupExport="TRUE" Certificate="FALSE" Export="TRUE"
                       RegistrationVisible="TRUE" LocalUserAdministrationVisible="TRUE"
                       LocalUserAdministrationChangeable="TRUE">
            <UDFName>Träger / Firma</UDFName>
        </UDFDefinition>
        <UDFDefinition Id="il_13738_udf_2" Type="TEXT" Visible="FALSE" Changeable="FALSE" Required="FALSE"
                       Searchable="TRUE" CourseExport="FALSE" GroupExport="FALSE" Certificate="FALSE" Export="TRUE"
                       RegistrationVisible="TRUE" LocalUserAdministrationVisible="TRUE"
                       LocalUserAdministrationChangeable="TRUE">
            <UDFName>Personalnummer</UDFName>
        </UDFDefinition>
        <UDFDefinition Id="il_13738_udf_3" Type="SELECT" Visible="TRUE" Changeable="TRUE" Required="FALSE"
                       Searchable="FALSE" CourseExport="FALSE" GroupExport="FALSE" Certificate="FALSE" Export="FALSE"
                       RegistrationVisible="FALSE" LocalUserAdministrationVisible="FALSE"
                       LocalUserAdministrationChangeable="FALSE">
            <UDFName>Externer Zugriff</UDFName>
            <UDFValue>Ja</UDFValue>
            <UDFValue>Nein</UDFValue>
        </UDFDefinition>
    </UDFDefinitions>
        `;

    const getContent = (user) => {
        const content = Object.keys(GLOBAL_ROLES).map((key) => {
            const roleName = GLOBAL_ROLES[key];
            return {
                '_name': 'Role',
                '_attrs': {
                    'Type': 'Global',
                    'Id': key
                },
                '_content': roleName
            };
        });

        content.push({
            '_name': 'Password',
            '_attrs': {
                'Type': 'PLAIN'
            },
            '_content': user.password ?? 'Start123!',
        });

        return content;
    };

    return XML_HEAD + toXML(users.map((user) => {
        return {
            'User': {
                '_attrs': {
                    'Id': 'imported',
                    'Action': 'Insert',
                    'Language': 'de'
                },
                'Login': user.email,
                '_content': getContent(user),
                'Firstname': user.firstName,
                'Lastname': user.lastName,
                'Gender': user.salutation ?? 'n',
                'Email': user.email,
                'Title': user.title,
            }
        };
    }), {header: false}) + '</Users>';
}
